import errorBoundary from '@ifeng-fe/errorBoundary';
import style from './index.css';
import PropTypes from 'prop-types';
import React, { useState, useEffect, useRef } from 'react';
import { formatImage } from '@ifeng-fe/public_method';

const Play = ({ videoInfo }) => {
    const [hasFixVideo, setHasFixVideo] = useState(false);
    const videoRef = useRef(null);
    const [scrollTop, setScrollTop] = useState(0);

    const fixVideoHandle = () => {
        setHasFixVideo(!hasFixVideo);

        if (hasFixVideo) {
            document.body.style.overflow = '';
            document.body.style.position = '';
            document.body.style.width = '';
            document.body.style.height = '';
            document.body.style.top = '0px';

            window.scrollTo(0, scrollTop);
        } else {
            const scrollTop = document.body.scrollTop || document.documentElement.scrollTop;

            document.body.style.position = 'fixed';
            document.body.style.overflow = 'hidden';
            document.body.style.width = '100%';
            document.body.style.top = `${-scrollTop}px`;
            setScrollTop(scrollTop);
        }
    };

    const formatSeconds = (seconds) => {
        const minutes = Math.floor(seconds / 60);
        const remainingSeconds = seconds % 60;
        const formattedMinutes = String(minutes).padStart(2, '0');
        const formattedSeconds = String(remainingSeconds).padStart(2, '0');

        return `${formattedMinutes}:${formattedSeconds}`;
    };

    useEffect(() => {
        if (hasFixVideo) {
            videoRef.current.play();
        }
    }, [hasFixVideo]);

    return videoInfo?.posterUrl ? (
        <div className={style.playBox}>
            <div className={style.play} onClick={fixVideoHandle}>
                <img className={style.playImage} src={formatImage(videoInfo?.posterUrl, 700, 394)} />
                <div className={style.icon} />
                {videoInfo?.length && <div className={style.time}>{formatSeconds(videoInfo.length)}</div>}
            </div>
            {hasFixVideo && (
                <div className={style.playFix}>
                    <video ref={videoRef} className={style.playFixVideo} controls={true} preload="meta" playsInline={true} src={videoInfo?.videoPlayUrl} />
                    <div className={style.close} onClick={fixVideoHandle} />
                </div>
            )}
        </div>
    ) : null;
};

Play.propTypes = {
    videoInfo: PropTypes.object,
};

export default errorBoundary(Play);
